import _ from "underscore";
import functionnal from "./functionnal.js";
import { cleanObject } from "./utils.js";
import Fuse from "fuse.js/basic";
import { DateTime } from "luxon";
import { v4 as uuid } from "uuid";
const isDate = (d) => _.isDate(d);
const months = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
];
const formaters = {
    self: this,
    applyId,
    capitaliseFirstLetter: function (word) {
        const firstLetter = word.charAt(0).toUpperCase();
        const otherLetters = word.slice(1);
        word = firstLetter + otherLetters;
        return word;
    },
    capitaliseEveryFirstLetter: function (sentence) {
        const arrayOfWords = sentence.split(" ");
        return _.map(arrayOfWords, function (word) {
            return formaters.capitaliseFirstLetter(word);
        }).join(" ");
    },
    convertMinToHMinString: function (minutes) {
        "use strict";
        if (!_.isNumber(minutes)) {
            return;
        }
        if (minutes < 60) {
            return minutes + "min";
        }
        else {
            let h, m;
            h = Math.floor(minutes / 60);
            m = minutes - h * 60;
            m = formaters.convertZeroToDoubleZero(m);
            return h + "h" + m + "min";
        }
    },
    convertZeroToDoubleZero: function (minutes) {
        "use strict";
        return this.convertSingleDigitToTwoDigits(minutes);
        //if (minutes === 0){
        //    return "00";
        //} else {
        //    return minutes;
        //}
    },
    formatNomPrenomForDisplay: function (npObject) {
        "use strict";
        return (npObject &&
            cleanObject(Object.assign({}, npObject, {
                nom: npObject.nom ? npObject.nom.toUpperCase() : null,
                prenom: npObject.prenom
                    ? formaters.capitaliseEveryFirstLetter(npObject.prenom.toLowerCase())
                    : null,
            })));
    },
    formatNameForenameForDisplay: function (nfObject) {
        "use strict";
        return (nfObject &&
            cleanObject(Object.assign({}, nfObject, {
                name: nfObject.name ? nfObject.name.toUpperCase() : null,
                forename: nfObject.forename
                    ? formaters.capitaliseFirstLetter(nfObject.forename.toLowerCase())
                    : null,
            })));
    },
    filterDateTimeForPureDate: function (dateTime) {
        "use strict";
        if (dateTime && isDate(dateTime)) {
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth();
            const day = dateTime.getDate();
            return new Date(year, month, day);
        }
        if (dateTime && "year" in dateTime) {
            const year = dateTime.year;
            const month = dateTime.month;
            const day = dateTime.day;
            return new Date(year, month, day);
        }
        throw new Error("should never reach this point");
    },
    getDateDuLundiFromDateTime: function (dateTime) {
        "use strict";
        let pureDate, dateDuLundi;
        pureDate = this.filterDateTimeForPureDate(dateTime);
        dateDuLundi = new Date(pureDate);
        dateDuLundi.setDate(pureDate.getDate() - pureDate.getDay() + 1);
        return dateDuLundi;
    },
    getHeureEnMinutesFromHeureMinuteObject: function (heureMinuteObject) {
        "use strict";
        return heureMinuteObject.heure * 60 + heureMinuteObject.minute;
    },
    getHourAsMinutesFromHMObject: function (hmObject) {
        return hmObject.hour * 60 + hmObject.minute;
    },
    getHeureMinuteObjectFromHeureEnMinutes: function (heureEnMinutes) {
        "use strict";
        if (heureEnMinutes > 1439) {
            return;
        }
        let heure, minute;
        heure = Math.floor(heureEnMinutes / 60);
        minute = heureEnMinutes - heure * 60;
        return {
            heure: heure,
            minute: minute,
        };
    },
    getHourMinutesFromMinutes: function (minutes) {
        "use strict";
        if (minutes > 1439) {
            return;
        }
        let hour, minute;
        hour = Math.floor(minutes / 60);
        minute = minutes - hour * 60;
        return {
            hour: hour,
            minute: minute,
        };
    },
    getHeureMinuteObjectFromHoraireString: function (horaireString) {
        "use strict";
        let HMArray;
        if (!_.isString(horaireString)) {
            return;
        }
        horaireString = horaireString.replace(/\s/g, ""); //on retire les espaces
        if (/^[0-9]{1,2}:[0-9]{2}$/.test(horaireString)) {
            HMArray = horaireString.split(":");
        }
        else if (/^[0-9]{1,2}h[0-9]{2}$/i.test(horaireString)) {
            HMArray = horaireString.split("h");
        }
        if (!Array.isArray(HMArray)) {
            return;
        }
        HMArray = HMArray.map(function (str) {
            return parseInt(str, 10);
        });
        if (Array.isArray(HMArray) &&
            HMArray.length === 2 &&
            _.isNumber(HMArray[0]) &&
            _.isNumber(HMArray[1])) {
            if (HMArray[0] >= 0 &&
                HMArray[0] <= 24 &&
                HMArray[1] >= 0 &&
                HMArray[1] <= 60) {
                return {
                    heure: HMArray[0],
                    minute: HMArray[1],
                };
            }
        }
    },
    getHourMinuteObjectFromHoraireString: function (horaireString) {
        const hm = this.getHeureMinuteObjectFromHoraireString(horaireString);
        if (!hm) {
            return;
        }
        return {
            hour: hm.heure,
            minute: hm.minute,
        };
    },
    getJourEnLettresFromDayNumber: function (dayNumber) {
        "use strict";
        const listeJours = [
            "Dimanche",
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi",
        ];
        return listeJours[dayNumber];
    },
    formatTelNumberForDisplay: function (tel) {
        "use strict";
        const frenchE164 = /^\+33[1-9]\d{8}$/;
        if (frenchE164.test(tel)) {
            const str = "(+33)" +
                "0" +
                tel.slice(3, 4) +
                " " +
                tel.slice(4, 6) +
                " " +
                tel.slice(6, 8) +
                " " +
                tel.slice(8, 10) +
                " " +
                tel.slice(10);
            return str.replace(/\s/g, ".");
        }
        let re = /([0-9]{2}\s){4}[0-9]{2}/;
        let valArray = [];
        if (re.test(tel)) {
            return tel.replace(/\s/g, ".");
        }
        re = /^[0-9]+$/;
        if (re.test(tel)) {
            for (let i = 0; i < tel.length; i += 2) {
                valArray.push(tel.substr(i, 2));
            }
            return valArray.join(".");
        }
        // re = /([0-9]{2}\.){4}[0-9]{2}/;
        // if (re.test(tel)) {
        //   return tel;
        // }
        return tel;
    },
    formatTelNumberForStoring: function (tel) {
        "use strict";
        if (!tel) {
            return;
        }
        tel = tel.replace(/\s/g, "");
        tel = tel.replace(/\./g, "");
        tel = tel.replace(/-/g, "");
        tel = tel.replace(/\//g, "");
        tel = tel.replace(/\(/g, "");
        tel = tel.replace(/\)0/g, "");
        const re = /^[0-9]{10}$/;
        const e164 = /^\+33[0-9]{9}$/;
        const pseudoInternational = /^33[0-9]{9}$/;
        if (re.test(tel)) {
            return tel;
        }
        if (e164.test(tel)) {
            return "0" + tel.slice(3);
        }
        if (pseudoInternational.test(tel)) {
            return "0" + tel.slice(2);
        }
        return undefined;
    },
    formatTelNumberForInternational: function (tel) {
        "use strict";
        if (!functionnal.existy(tel) || !formaters.formatTelNumberForStoring(tel)) {
            return undefined;
        }
        let outputTel = tel.toString();
        outputTel = formaters.formatTelNumberForStoring(outputTel);
        outputTel = outputTel.replace(/^0/, "");
        outputTel = 33 + outputTel;
        return outputTel;
    },
    formatTelNumberForE164: (tel) => {
        if (!functionnal.existy(tel)) {
            return undefined;
        }
        const international = formaters.formatTelNumberForInternational(tel);
        if (international) {
            return "+" + international;
        }
        return undefined;
    },
    formatDateForDisplay: (date) => {
        return DateTime.fromJSDate(date).setLocale("fr").toFormat("dd LLLL yyyy");
    },
    formatDateAsDDN: (date) => {
        return DateTime.fromJSDate(date).setLocale("fr").toFormat("dd/MM/yyyy");
    },
    formatDateForDisplayWithDay: (date) => DateTime.fromJSDate(date).setLocale("fr").toFormat("EEEE dd LLLL"),
    //prend un nombre sous forme de nombre ou de string
    //renvoie une string avec un zéro devant si il n'y a qu'un chiffre, sinon renvoie le nombre en string
    //non modifié
    convertSingleDigitToTwoDigits: function (inputNumber) {
        "use strict";
        //si c'est un nombre on convertit en string
        let number;
        if (_.isNumber(inputNumber)) {
            number = inputNumber.toString();
        }
        else {
            number = inputNumber;
        }
        //si c'est une string qui ne correspond pas à un nombre on renvoie undefined
        if (_.isString(inputNumber)) {
            if (!_.isNumber(parseInt(inputNumber, 2))) {
                throw new Error("convertSingleDigitToTwoDigits : inputNumber n'est pas un nombre");
            }
        }
        if (number.toString().length === 2) {
            return number;
        }
        if (number.toString().length === 1) {
            return "0".concat(number.toString());
        }
        return number;
    },
    formatHMObjectForDisplay: function (hmObject) {
        if (hmObject.heure > 23 || hmObject.minute > 59) {
            throw new Error("Heure ou minute invalide dans formatHMObjectForDisplay " +
                JSON.stringify(hmObject, null, 2));
        }
        if (hmObject.heure < 0 || hmObject.minute < 0) {
            throw new Error("Heure ou minute invalide dans formatHMObjectForDisplay " +
                JSON.stringify(hmObject, null, 2));
        }
        return (formaters.convertSingleDigitToTwoDigits(hmObject.heure) +
            ":" +
            formaters.convertSingleDigitToTwoDigits(hmObject.minute));
    },
    formatHourMinuteObjectForDisplay: function (hourMinuteObject) {
        if (hourMinuteObject.hour > 23 || hourMinuteObject.minute > 59) {
            throw new Error("Heure ou minute invalide dans formatHMObjectForDisplay " +
                JSON.stringify(hourMinuteObject, null, 2));
        }
        if (hourMinuteObject.hour < 0 || hourMinuteObject.minute < 0) {
            throw new Error("Heure ou minute invalide dans formatHMObjectForDisplay " +
                JSON.stringify(hourMinuteObject, null, 2));
        }
        return (formaters.convertSingleDigitToTwoDigits(hourMinuteObject.hour) +
            ":" +
            formaters.convertSingleDigitToTwoDigits(hourMinuteObject.minute));
    },
    getAgeFromDDN: function (ddn, now) {
        "use strict";
        if (_.isDate(ddn)) {
            let ageDifMs = (now ? now.getTime() : Date.now()) - ddn.getTime(), ageDate = new Date(ageDifMs), // miliseconds from epoch
            age = Math.abs(ageDate.getFullYear() - 1970);
            return { annees: age, mois: ageDate.getMonth() };
        }
    },
    formatAgeObjectToDecimalYears: (ageObject) => ageObject.annees + ageObject.mois / 12,
    formatDDNForStoring: function (ddn) {
        if (!ddn) {
            return;
        }
        let output = replaceDotBySlashInDdn(ddn);
        output = parseDdnStringWithoutSeparator(output);
        return normalizeDigits(output);
    },
    parseDateString: function (dateString) {
        const trimmedDateString = dateString.trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedDateString)) {
            const parsedISODate = DateTime.fromFormat(trimmedDateString, "yyyy-MM-dd");
            return parsedISODate.isValid ? parsedISODate.toJSDate() : null;
        }
        let dateSplitted;
        if (trimmedDateString.includes("/")) {
            dateSplitted = trimmedDateString.split("/");
        }
        else if (trimmedDateString.includes("_")) {
            dateSplitted = trimmedDateString.split("_");
        }
        else if (trimmedDateString.includes("-")) {
            dateSplitted = trimmedDateString.split("-");
        }
        else if (trimmedDateString.includes(".")) {
            dateSplitted = trimmedDateString.split(".");
        }
        else if (trimmedDateString.includes(" ")) {
            dateSplitted = trimmedDateString.split(" ").filter((c) => c !== "");
        }
        else {
            const tryParsed = parseDdnStringWithoutSeparator(trimmedDateString);
            if (tryParsed.includes("/")) {
                dateSplitted = tryParsed.split("/");
            }
            else {
                return null;
            }
        }
        const parsed = [
            parseDay(dateSplitted[0]),
            parseMonth(dateSplitted[1]),
            parseYear(dateSplitted[2]),
        ];
        if (parsed.some((n) => n === null)) {
            return null;
        }
        //l'année doit être inférieure à 2100
        if (parsed[2] > 2100) {
            return null;
        }
        return new Date(parsed[2], parsed[1], parsed[0]);
    },
    parseYear: function (ddnString) {
        "use strict";
        const annee = parseInt(ddnString, 10);
        let returnValue;
        if (annee > 1900) {
            returnValue = annee.toString();
        }
        else {
            let thisAnnee = new Date().getFullYear();
            const re3 = /^20/;
            thisAnnee = parseInt(thisAnnee.toString().replace(re3, ""), 10);
            if (annee <= thisAnnee) {
                returnValue = "20" + convertOneDigitToTwoDigits(annee.toString());
            }
            else {
                returnValue = "19" + annee.toString();
            }
        }
        return returnValue;
    },
    addToHM(hm, value) {
        "use strict";
        const heureEnMinutes = this.getHeureEnMinutesFromHeureMinuteObject(hm);
        return this.getHeureMinuteObjectFromHeureEnMinutes(heureEnMinutes + value);
    },
    soustractFromHM(hm, value) {
        "use strict";
        return this.getHeureMinuteObjectFromHeureEnMinutes(this.getHeureEnMinutesFromHeureMinuteObject(hm) - value);
    },
    nullToEmptyString(str) {
        return str || "";
    },
    voidSlashify(value) {
        return value != null ? value : "---";
    },
    splitSentenceByWords: (sentence) => sentence.match(/\b(\w+)\b/g) || [],
    formatObjForLogging: (obj) => JSON.stringify(obj, null, 2),
};
// var isValidDdnString = function(ddn: string) {
//   "use strict";
//   var re = /[0-3]?[0-9]\/[01]?[0-9]\/[12][09][0-9][0-9]/;
//   return re.test(ddn);
// };
const replaceDotBySlashInDdn = function (ddn) {
    "use strict";
    //si le séparateur de date est un point
    const re = /[0-3]*[0-9]\.[01]*[0-9]\.([12][09])*[0-9][0-9]/;
    if (re.test(ddn)) {
        const re2 = /\./g;
        ddn = ddn.replace(re2, "/");
    }
    return ddn;
};
const parseDdnStringWithoutSeparator = function (ddn) {
    "use strict";
    //pas de séparateur ! Ne marche qu'avec les dates DDMMYYYY
    let re = /^[0-3][0-9][01][0-9][12][09][0-9][0-9]$/;
    if (re.test(ddn)) {
        let jour = ddn[0] + ddn[1];
        let mois = ddn[2] + ddn[3];
        let annee = ddn[4] + ddn[5] + ddn[6] + ddn[7];
        return jour + "/" + mois + "/" + annee;
    }
    re = /^[0-3][0-9][01][0-9][0-9][0-9]$/;
    if (re.test(ddn)) {
        let jour = ddn[0] + ddn[1];
        let mois = ddn[2] + ddn[3];
        let annee = formaters.parseYear(ddn[4] + ddn[5]);
        return jour + "/" + mois + "/" + annee;
    }
    return ddn;
};
const convertOneDigitToTwoDigits = function (digit) {
    "use strict";
    if (/^[0-9]$/.test(digit)) {
        return "0" + digit;
    }
    else {
        return digit;
    }
};
const normalizeDigits = function (ddn) {
    let dmy = ddn.split("/");
    if (dmy.length !== 3) {
        return ddn;
    }
    dmy[0] = convertOneDigitToTwoDigits(dmy[0]);
    dmy[1] = convertOneDigitToTwoDigits(dmy[1]);
    dmy[2] = formaters.parseYear(dmy[2]);
    return dmy.join("/");
};
const parseMonth = (str) => {
    const num = parseInt(str);
    if (!Number.isFinite(num)) {
        if (months.includes(str)) {
            return months.indexOf(str);
        }
        const fuse = new Fuse(months, {
            threshold: 0.7,
            includeScore: true,
            minMatchCharLength: 3,
        });
        const result = fuse.search(str);
        if (result.length > 0) {
            return result[0].refIndex;
        }
        return null;
    }
    if (num < 1 || num > 12) {
        return null;
    }
    return num - 1;
};
const parseDay = (str) => {
    const num = parseInt(str);
    if (!Number.isFinite(num)) {
        return null;
    }
    if (num < 1 || num > 31) {
        return null;
    }
    return num;
};
const parseYear = (str) => {
    const parsed = parseInt(formaters.parseYear(str), 10);
    if (parsed != parsed) {
        //NaN
        throw new Error("input to parseYear cannot be converted to a number");
    }
    return parsed;
};
function applyId(obj) {
    if ("_id" in obj) {
        throw new Error("cannot add an object which already has an _id in applyId " +
            JSON.stringify(obj));
    }
    return { ...obj, _id: uuid() };
}
export default formaters;
//# sourceMappingURL=formaters.js.map